import mainnetTokensJson from './ethereumMainnetTokenList.json';
export var celerBridgeMainnetTokens = mainnetTokensJson.map(function (cToken) { return ({
    value: cToken.token.address,
    address: cToken.token.address,
    decimals: cToken.token.decimal,
    symbol: cToken.token.symbol,
    chainId: 1,
    name: cToken.name,
    logoURI: cToken.icon,
    type: 'CELER_BRIDGE',
}); });
